import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import * as Store from '../../store';
import { store } from '../../store';

import Header from '../header';
import Sidebar from '../sidebar';
import Footer from '../footer';
import Login from '../../views/login';

import template from './layout.vue';
import router from '../../router';

// Styles and fonts
import '../../../node_modules/@mdi/font/css/materialdesignicons.min.css';
import '../../../node_modules/flag-icon-css/css/flag-icon.min.css';
import '../../../node_modules/font-awesome/css/font-awesome.min.css';

@Component({
    mixins: [template],
    store,
    components: {
        Header,
        Sidebar,
        Footer,
        Login
    },
    router
})

export default class Layout extends Vue {

    constructor() {
        super();
    }

    mounted() {

    }

    isLoggedIn() {
        return Store.readLoggedInState(this.$store);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/layout/index.ts